

































import Vue from "vue";
import Space from "@/components/mobile/Space.vue";
import { PARTNERS } from "@/config";

export default Vue.extend({
  name: "Partnerships",
  data() {
    return {
      partners: PARTNERS
    };
  },
  components: {
    MobileSpace: Space
  },
  methods: {
    toConversion(
      baseArray: {
        name: string;
        href: string;
        image: any;
      }[]
    ) {
      const n = 3;
      let len = baseArray.length;
      let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      let res = [];
      for (let i = 0; i < lineNum; i++) {
        let temp = baseArray.slice(i * n, i * n + n);
        res.push(temp);
      }
      return res;
    }
  }
});
